module.exports = __webpack_public_path__ + "static/img/jovo.420cf35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/presslogo/jovo.png
// module id = n02W
// module chunks = 0